import Instance from "../../../../Axios";

// New Actions for the app

const GetCredEstadosCount = () => async (dispatch) => {
  await Instance()
    .get(`/credenciacoes/credByCount`)
    .then(({ data }) => {
      dispatch({ type: "GET_CRED_ESTADOS_COUNT", payload: data.yData });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetCredEstadosCount;
